import React from 'react'
import { ForwardRefExoticComponent, SVGProps } from 'react'

import { TextSize } from '@factorialco/f0-react/icons/app'
import { FormsElementTypeEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import TextElementQuestion from 'modules/forms/components/QuestionComponent/TextElementQuestion'
import { Element } from 'modules/forms/lib/Element'
import { Answer, Options } from 'modules/forms/lib/types'

/**
 * TextElement class for simple text input elements.
 * Extends the base Element class.
 */
export class TextElement extends Element {
  static create({ label, options = {} }: { label: string; options: Options }): TextElement {
    const el = new TextElement({
      label,
      description: options.description,
      mandatory: options.mandatory || options.locked, //locked element are always mandatory
    })
    if (options.locked) {
      el.lock()
    }

    return el
  }
  /**
   * Get the name of the element
   */
  getName(): string {
    return i18n.t('forms.modals.elements.text')
  }

  /**
   * Get the type of the element
   */
  getType(): FormsElementTypeEnum {
    return 'text'
  }

  /**
   * Get the icon for the element
   */
  getIcon(): ForwardRefExoticComponent<SVGProps<SVGSVGElement>> {
    return TextSize
  }

  getPreviewComponent(disabled?: boolean): React.ReactNode {
    return <TextElementQuestion element={this} disabled={disabled} />
  }

  getQuestionComponent(onChange: (answer: Answer) => void): React.ReactNode {
    return <TextElementQuestion element={this} onChange={onChange} />
  }
}
